import multasRenainfOrgaoSaga from './multasRenainfOrgao/saga';
import multasRenainfPlacaSaga from './multasRenainfPlaca/saga';

export const multasRenainfOrgao = multasRenainfOrgaoSaga;
export const multasRenainfPlaca = multasRenainfPlacaSaga;
